import { Button, FormField, Modal } from '@chikara/ui';
import { formatCardNumber } from '@/features/card/components/ActivateCardModal/activateCard.validators';
import { ActivateCardStepProps } from '@/features/onboarding/types/onboarding.types';
import { useOnboardingStep } from './useOnboardingStep';
import styles from '../Onboarding.module.css';
import { t } from '@/i18n';


export function ActivateCardStep({ user, onSuccess }: ActivateCardStepProps) {
    const { state,
        CARD_MAX_LENGTH,
        error,
        handleCardNumberChange,
        handleConfirmCardNumberChange,
        handleSubmitActivateCard,
        setState,
    } = useOnboardingStep({ user, onSuccess });

    return (
        <div className={styles.stepContainer}>
            <h2 className={styles.title}>{t('onboarding.activateCard.title')}</h2>
            <p className={styles.subtitle}>{t('onboarding.activateCard.subtitle')}</p>

            <form onSubmit={(e) => { e.preventDefault(); handleSubmitActivateCard(); }} className={styles.formView}>
                <FormField
                    label={t('onboarding.activateCard.panDigits')}
                    value={formatCardNumber(state.cardNumber)}
                    onChange={handleCardNumberChange}
                    error={state.errors['cardNumber']}
                    maxLength={CARD_MAX_LENGTH}
                    placeholder={t('dashboard.card.activateModal.step1.cardNumberPlaceholder')}
                />
                <FormField
                    label={t('dashboard.card.activateModal.step1.confirmCardNumberLabel')}
                    value={formatCardNumber(state.confirmCardNumber)}
                    onChange={handleConfirmCardNumberChange}
                    error={state.errors['confirmCardNumber']}
                    maxLength={CARD_MAX_LENGTH}
                    placeholder={t('dashboard.card.activateModal.step1.cardNumberPlaceholder')}
                    onPaste={(e) => e.preventDefault()}
                    onCopy={(e) => e.preventDefault()}
                />

                {error && <p className={styles.errorText}>{error}</p>}

                <div className={styles.actions}>
                    <Button type="submit" className={styles.submitButton} disabled={state.errors['cardNumber'] || state.errors['confirmCardNumber']}>
                        {t('onboarding.activateCard.action')}
                    </Button>
                </div>
            </form>

            <Modal
                isOpen={state.isFailed}
                onClose={() => setState((prev: any) => ({ ...prev, isFailed: false }))}
                title=""
                showCloseButton={false}
                contentSize="sm"
            >
                <div style={{ textAlign: 'center', display: 'flex', flexDirection: 'column', gap: '16px' }}>
                    <h2 style={{ fontSize: '20px', color: '#1a1a1a' }}>
                        {t('dashboard.card.activateModal.failure.title')}
                    </h2>
                    <p style={{ color: '#4b5563', lineHeight: '1.5' }}>
                        {t('dashboard.card.activateModal.failure.description')}
                    </p>
                    <Button
                        variant="primary"
                        onClick={() => setState((prev: any) => ({ ...prev, isFailed: false }))}
                        fullWidth
                    >
                        {t('dashboard.card.activateModal.failure.button')}
                    </Button>
                </div>
            </Modal>
        </div>
    );
}
